(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vinci-menopause-listicle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vinci-listicle-carousel')) {
  customElements.define('vinci-listicle-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const rail = this.querySelector('.vml__gallery');
      const buttons = [...this.querySelectorAll('button[data-direction]')];
      if (!rail) return;
      const update = () => {
        buttons[0].disabled = rail.scrollLeft <= 2;
        buttons[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      for (const button of buttons) button.addEventListener('click', () => {
        const step = rail.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap);
        rail.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.controller.signal });
      rail.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(rail);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
